<mat-nav-list>
  <div class="content-sheet">
    <ng-container *ngFor="let item of info?.menu">
      <li *ngIf="item?.active" mat-list-item class="list-menu">
        <a *ngIf="item.type === 'href';else rota" [class.active]="isActive(item.rota)" [href]="item.rota">
          <div>
            <span>{{item.label}} {{ item?.itens != undefined ? '(' + item?.itens + ')' : ''}}</span>
            <img *ngIf="isActive(item.rota)" src="assets/images/svgs/chevron-right-check.svg" alt="link">
            <img *ngIf="!isActive(item.rota)" src="assets/images/svgs/chevron-right.svg" alt="link">
          </div>
        </a>
        <ng-template #rota>
          <a [class.active]="isActive(item.rota)" (click)="openLink($event, item.rota)">
            <div>
              <span>{{item.label}} {{ item?.itens != undefined ? '(' + item?.itens + ')' : ''}}</span>
              <img *ngIf="isActive(item.rota)" src="assets/images/svgs/chevron-right-check.svg" alt="link">
              <img *ngIf="!isActive(item.rota)" src="assets/images/svgs/chevron-right.svg" alt="link">
            </div>
          </a>
        </ng-template>
      </li>
    </ng-container>
  </div>
</mat-nav-list>